import { TreeNavigatorLogic } from '../../../tree/navigation/TreeNavigatorLogic';
import { Datatype } from '../../expressions/datatype/Datatype';
import {
  IReference,
  ReferenceType,
} from '../../expressions/references/IReference';
import { ICodeWidget, hasCode } from '../ICodeWidget';
import {
  IWidgetOptionValue,
  Widget,
  WidgetCategory,
  WidgetMainType,
  WidgetType,
} from '../Widget';
import { IRootWidget } from '../repository/containers/root/IRootWidget';

export const createTestTree = (...children: Widget[]) => {
  const root: IRootWidget = {
    type: WidgetType.Root,
    mainType: WidgetMainType.Root,
    children,
  };
  TreeNavigatorLogic.computeOrder(root);
  return root;
};

export const _w = (widget: Widget): Widget => {
  return widget;
};

export const _winput = (
  code: string,
  type?: WidgetType,
  options?: Partial<Widget>,
): Widget =>
  _w({
    id: `${code}_id`,
    code,
    label: [{ text: 'Campo ' + code }],
    mainType: WidgetMainType.Input,
    type: type ?? WidgetType.Text,
    ...options,
  } as any);

export const _wquestion = (code: string, ...children: Widget[]) =>
  _w({
    id: `${code}_id`,
    code,
    label: [{ text: 'Container ' + code }],
    mainType: WidgetMainType.Container,
    type: WidgetType.Question,
    children,
  } as any);

export const _wselect = (code: string, options?: string[]): Widget =>
  _w({
    id: `${code}_id`,
    code,
    label: [{ text: 'Select ' + code }],
    mainType: WidgetMainType.Input,
    type: WidgetType.Select,
    options: options?.map(
      o =>
        ({
          type: 'option',
          value: o,
          label: [{ type: 'text', text: o }],
        } as IWidgetOptionValue),
    ),
  } as any);

export const _warray = (code: string, ...children: Widget[]) =>
  _w({
    id: `${code}_id`,
    code,
    label: [{ text: 'Lista Ripetibile ' + code }],
    mainType: WidgetMainType.Container,
    type: WidgetType.Repeatable,
    children,
  } as any);

export const _wsubsection = (code: string, ...children: Widget[]) =>
  _w({
    id: `${code}_id`,
    code,
    label: [{ text: 'SottoSezione ' + code }],
    mainType: WidgetMainType.Container,
    category: WidgetCategory.Advanced,
    type: WidgetType.Subsection,
    children,
  } as any);

export const _tref = (
  name: string,
  options?: {
    dtype?: Datatype;
    widgetType?: WidgetType;
  },
) =>
  ({
    id: name,
    type: ReferenceType.Widget,
    widgetType: options?.widgetType ?? WidgetType.Text,
    path: [],
    code: name,
    label: name,
    field: { type: options?.dtype ?? Datatype.String },
  } as IReference);

/**
 * Dato un albero e un codice, restituisce il widget corrispondente.
 */
export function getWidgetByCode(
  tree: IRootWidget,
  code: string,
): Widget | undefined {
  return tree.children
    .filter((w): w is Widget & ICodeWidget => hasCode(w))
    .find(c => c.code === code);
}
